import benefitsEnrollmentNewRoutes from "@/modules/enrollment-new/router/routes"
import homeRoutes from "@/modules/home/router/routes"
import healthWalletRoutes from "@/modules/health-wallet/router/routes"
import instructionRoutes from "@/modules/instructions/router/routes"
import loginRoutes from "@/modules/login/router/routes"
import phoneClaimRoutes from "@/modules/phone-claim/router/routes"
import { usePhoneClaimGateStore } from "@/modules/phone-claim/stores/phone-claim-gate-store"
import { isEmbeddedContext } from "@common/services/embed-service"
import schedulingRoutes from "@/modules/scheduling/router/routes"
import careNavRoutes from "@/modules/care-nav/router/routes"
import GuardianRunner from "@/router/guardian-runner"
import { createEnsureNotEmbedded } from "@common/router/embed-guards"
import analyticsService from "@/services/analytics/analytics-service"
import planShoppingRoutes from "@/modules/plan-shopping/router/routes"
import embedRoutes from "@/modules/embed/router/routes"
import { useAppVersionCheck } from "@common/composables/utility/app-version-check"
import { initializeVersionReload } from "@common/services/version-reload-service"
import { createRouter, createWebHistory } from "vue-router"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    ...loginRoutes,
    ...phoneClaimRoutes,
    ...homeRoutes,
    ...healthWalletRoutes,
    ...benefitsEnrollmentNewRoutes,
    ...instructionRoutes,
    ...schedulingRoutes,
    ...careNavRoutes,
    ...planShoppingRoutes,
    ...embedRoutes,
    { path: "/enroll-setup", name: "enroll-setup", redirect: "/login" },
    { path: "/start", name: "enroll-start", redirect: "/login" },
    { path: "/vitable", name: "enroll-landing", redirect: "/login" },
    {
      path: "/:pathMatch(.*)*",
      redirect: { name: "login" }
    }
  ],
  scrollBehavior(_, __, ___) {
    return { top: 0 }
  }
})

router.afterEach((to, from) => {
  analyticsService.pageViewed({
    name: to.name,
    path: to.path,
    from_name: from ? from.name : null,
    from_path: from ? from.path : null,
    ...to.query
  })
})

router.beforeEach(createEnsureNotEmbedded(() => router, "embed-employee-dashboard"))

// Phone-claim gate is mandatory: while a claim pends, every
// navigation lands on the gate. Embedded sessions come from the parent
// frame with no login flow — the parent surface owns auth, so no gate.
router.beforeEach((to) => {
  if (isEmbeddedContext()) return true

  const gateStore = usePhoneClaimGateStore()
  if (!gateStore.isPending) return true
  if (["phone-claim", "login", "forgot-password"].includes(String(to.name))) return true

  return { name: "phone-claim", query: { redirectedFromPath: to.fullPath } }
})

GuardianRunner.init([])

const { newVersionAvailable } = useAppVersionCheck()
initializeVersionReload(router, newVersionAvailable)

export default router
